export const SET_SELECTED_LANGUAGE = 'SET_SELECTED_LANGUAGE'
